import gql from 'graphql-tag'

const carrierServicesGetQuery = gql`
  query carrierServicesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object) {
    carrierServicesGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "CarrierServices", method: "POST", path: "carrier-service/list") {
      results
      paging
    }
  }
`

export default carrierServicesGetQuery
